import React from 'react';
import { EmailVerificationResultProps } from '../../organisms/EmailVerificationResult/EmailVerificationResult';
import EmailVerificationResult from '../../organisms/EmailVerificationResult';

const ConfirmedEmail = (props: EmailVerificationResultProps): JSX.Element => (
  <EmailVerificationResult {...props} />
);

export default ConfirmedEmail;
